import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import moment from "moment";
import { MatFormField, MatSuffix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker
} from "@angular/material/datepicker";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-date-picker",
  templateUrl: "./date-picker.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./date-picker.component.scss"],
  imports: [
    MatFormField,
    MatInput,
    MatDatepickerInput,
    FormsModule,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    TranslateModule
  ]
})
export class DatePickerComponent {
  @Input() placeholderPath: string;
  @Input() selectedDate: Date;

  @Output() date: EventEmitter<Date> = new EventEmitter();

  constructor() {}

  public onDateChange(datePickerEvent): void {
    this.date.emit(datePickerEvent.value);
  }

  public onInputChange(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    const date = moment(value, "DD/MM/YYYY", true);
    if (date.isValid()) {
      this.date.emit(date.toDate());
    }
  }

  dateFilter = (d: Date | null): boolean => {
    const currentDate = new Date();

    currentDate.setHours(0, 0, 0, 0);
    return d === null || d < currentDate;
  };
}
